export const blockOptions = [
  { value: 'block_returns', label: 'Bloquear devoluciones' },
  { value: 'block_variant_exchanges', label: 'Bloquear cambios de variante' },
  { value: 'block_exchange_for_other', label: 'Bloquear cambios por otros productos' },
]
